import React from 'react';
import Text from '../../../../../Components/Base/Text/Text';
import { getSickLeaveStatusTranslationKey } from '../../../../CSSZSickLeaveCertificate/Helpers/sickLeaveStatusMap.helper';

interface Props {
	status?: string;
}

const ManagerSickLeaveStatus: React.FC<Props> = ({ status }) => {
	const tx = getSickLeaveStatusTranslationKey(status);

	if (tx) {
		return <Text tx={tx} />;
	}

	return <span>{status ?? ''}</span>;
};

export default ManagerSickLeaveStatus;
